import React, { useState } from 'react';
import { Archive } from '@phosphor-icons/react';
import { FluxObject } from '../AgentsSidebar/context';
import { useDataSidebarContext } from './context';
import { Item } from './Item';
import { ActionMenu } from './ActionMenu';

interface ObjectItemProps {
  object: FluxObject;
  onEdit?: (object: FluxObject) => void;
  onDelete?: (object: FluxObject) => void;
  isNested?: boolean;
}

export const ObjectItem: React.FC<ObjectItemProps> = ({
  object,
  onEdit,
  onDelete,
  isNested = true,
}) => {
  const { activeObjectId, onObjectClick } = useDataSidebarContext();
  const [anchorEl, setAnchorEl] = useState<HTMLElement | null>(null);

  const handleMenuClick = (anchor: HTMLElement) => {
    setAnchorEl(anchor);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  return (
    <>
      <Item
        icon={<Archive size={16} />}
        label={object.name}
        isActive={activeObjectId === object.id}
        isNested={isNested}
        onClick={() => onEdit && onEdit(object)}
        onMenuClick={handleMenuClick}
      />
      <ActionMenu
        anchorEl={anchorEl}
        onClose={handleClose}
        onEdit={onEdit ? () => onEdit(object) : undefined}
        onDelete={onDelete ? () => onDelete(object) : undefined}
        showEdit={true}
      />
    </>
  );
};
